export default __webpack_public_path__ + "static/media/up.b1a8d0e7.svg";